require('./retailLoanAccounts.scss');
require('./retailLoanAccounts.override.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

//@components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');

// @core
const { formatText } = require('core/i18n').i18n;

// @utilities
const {
    getFilteredAccountIndexes,
    getFirstFilteredAccountIndexThatIsnotBlocked } = require('../../../../loansUtilities/loansHelper');

class RetailLoanAccounts extends React.Component {

    componentDidMount() {
        const { setSelectedAccount, immRetailLoan, immAccounts } = this.props;

        if (!immRetailLoan.get('selectedAccount')) {
            setSelectedAccount(getFirstFilteredAccountIndexThatIsnotBlocked(immAccounts));
        }
    }

    render() {
        const { immAccounts, setSelectedAccount, immRetailLoan } = this.props;

        const accountSelectLabel = formatText('contractLoanAccount-accountSelectLabel');
        const accountIndexes = getFilteredAccountIndexes(immAccounts);
        const selectedAccount = immRetailLoan.get('selectedAccount') || getFirstFilteredAccountIndexThatIsnotBlocked(immAccounts);
        const disclaimer = {
            warning: 'contractRetailLoanStepThree-contractRetailLoanStepThree_blockedAccountsWarning',
            important: 'contractRetailLoanStepThree-contractRetailLoanStepThree_blockedAccountsImportant'
        };

        return !immAccounts.get('blockedAccountsLoading') ? (
            <div className="retail-loan-accounts__container">
                <div className="retail-loan-accounts__dropdown">
                    <DropdownAccounts
                        blockedAccountsAll={immAccounts.get('blockedAccountsAll')}
                        blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                        disclaimer={disclaimer}
                        immAccounts={immAccounts.get('byId')}
                        label={accountSelectLabel}
                        accountsIndexes={accountIndexes.toJS()}
                        onAccountChange={setSelectedAccount}
                        currentAccountId={selectedAccount}
                        tooltipMsg={formatText('contractRetailLoanStepThree-accountTooltip')}
                        tooltipCustomClass={"retail-loan-accounts__tooltip"}
                        showBalance
                        showNegativeBalanceAccounts
                    />
                </div>
            </div>
        ) : <LoadingSection />;
    }
}

RetailLoanAccounts.propTypes = {
    immRetailLoan: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    setSelectedAccount: PropTypes.func.isRequired
};

module.exports = RetailLoanAccounts;
